/**
 * Contact configuration — single source of truth for outbound CTAs.
 *
 * The UAE WhatsApp Business number powers every "Book a demo" / "Contact us"
 * CTA on the site. Direct messaging is the preferred channel in the GCC, so
 * the buttons open wa.me with a prefilled context message.
 *
 * To update: replace WHATSAPP_NUMBER below with the international format
 * (no leading "+" or spaces, e.g. 971501234567).
 */

// UAE WhatsApp Business number (Pablo / arkos.labs · +971 58 523 3250)
export const WHATSAPP_NUMBER = "971585233250"

const PREFILLED = "Hi — I'd like to book a VaultBridge demo."

export const WHATSAPP_LINK =
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILLED)}`

export const ARKOS_URL = "https://www.arkoslabs.io/"
